<template>
    <div class="challenge__success">

        <div class="challenge__success__header">
            <div class="challenge__success__header__progress">
                <ProgressIcon :progress="progress"></ProgressIcon>
            </div>
            <h1>{{ headline }}</h1>
            <p v-html="motivationText"></p>
            <router-link to="/" class="button button--small button--primary">
                Weiter geht's
            </router-link>
        </div>

        <div class="challenge__success__statistics">
            <div class="challenge__success__statistics__content">
                <h2>Statistik</h2>
                <p>Die Erfolge der bereits absolvierten Einheiten können sich schon sehen lassen!</p>

                <div class="challenge__success__statistics__wrapper">
                    <div class="challenge__success__statistics__item challenge__success__statistics__item--small">
                        <img src="@/assets/ic_64_flame.svg" alt="">
                        <div class="challenge__success__statistics__item__left">
                            <div class="challenge__success__statistics__item__value">
                                {{ totalEnergyExpended.toLocaleString() }} <span>kcal</span>
                            </div>
                            <div class="challenge__success__statistics__item__label">
                                Aktivitätskalorien (inkl. optionale Workouts)
                            </div>
                        </div>
                    </div>
                    <div class="challenge__success__statistics__item challenge__success__statistics__item--small">
                        <img src="@/assets/ic_64_stopclock.svg" alt="">
                        <div class="challenge__success__statistics__item__left">
                            <div class="challenge__success__statistics__item__value">
                                {{ totalHours }}<span>h</span> {{ totalMinutes }}<span>m</span>
                            </div>
                            <div class="challenge__success__statistics__item__label">
                                Trainingsdauer (inkl. optionale Workouts)
                            </div>
                        </div>
                    </div>
                    <div class="challenge__success__statistics__item challenge__success__statistics__item--small">
                        <img src="@/assets/ic_64_progress.svg" alt="">
                        <div class="challenge__success__statistics__item__left">
                            <div class="challenge__success__statistics__item__value">
                                {{ this.numberOfFinishedExercises}}/{{ numberOfExercises }} <span>Einheiten</span>
                            </div>
                            <div class="challenge__success__statistics__item__label">
                                Bisher absolviert (ohne optionale Einheiten)
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ProgressIcon from '@/components/ProgressIcon';

    export default {
        name: "FitnessplanChallengeIntermediate",
        data() {
            return {
                numberOfExercises: 0,
                numberOfFinishedExercises: 0,
                progress: 0,
                totalEnergyExpended: 0,
                totalMinutes: 0,
                totalHours: 0,
                headline: "",
                motivationText: "",
            };
        },
        components: {
            ProgressIcon
        },
        mounted() {
            this.init();
        },
        methods: {
            async init() {
                // OPTIMIERT: Lade Daten aus localStorage statt Neuberechnung
                const storedData = localStorage.getItem('challengeIntermediateData');
                if (storedData) {
                    console.log('Loading challenge data from localStorage...');
                    const challengeData = JSON.parse(storedData);
                    
                    // Setze alle benötigten Werte direkt
                    this.totalEnergyExpended = challengeData.totalEnergyExpended;
                    this.totalHours = challengeData.totalHours;
                    this.totalMinutes = challengeData.totalMinutes;
                    this.progress = challengeData.progress;
                    this.numberOfExercises = challengeData.numberOfExercises;
                    this.numberOfFinishedExercises = challengeData.numberOfFinishedExercises;
                    this.headline = challengeData.headline;
                    this.motivationText = challengeData.motivationText;
                    
                    // Bereinige localStorage nach Verwendung
                    localStorage.removeItem('challengeIntermediateData');
                    
                } else {
                    // Keine Daten verfügbar - Cloud Function Integration erforderlich
                    console.error('No challenge data found! Cloud Function integration required.');
                    return;
                }
                
                // Markiere Motivation als angezeigt
                let uniqueChallengeId = this.$route.query.unique_challenge_id;
                let motivationId = parseInt(this.$route.query.motivationId);
                
                if (uniqueChallengeId && motivationId) {
                    this.$store.commit('addMotivationTextAsDisplayed', {
                        uniqueChallengeId: uniqueChallengeId,
                        motivationId: motivationId
                    });
                }
            }
        },
    };
</script>

<style lang="scss" scoped>
    .challenge__success {
        margin-bottom: -20px !important;
    }
</style>
